module.exports = __webpack_public_path__ + "static/media/emptyHeart.969b1791.svg";